import styled from '@emotion/styled';

export const PointerWrap = styled.div({
  position: 'relative',
});

export const PointerInfoAnchor = styled.a({
  background: '#B5E8FF',
  transform: 'translate(-50%, -140%)',
  width: '240px',
  padding: '10px',
  textDecoration: 'none',
  display: 'block',
});

export const PointerInfo = styled.div({
  background: '#fff',
  position: 'absolute',
  bottom: '0px',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '325px',
  padding: '15px 50px',
  boxShadow: '-1px 1px 6px 0 rgba(0,0,0,0.2)',
  borderRadius: '6px',
  boxSizing: 'border-box',
  textAlign: 'center',

  button: {
    fontSize: '15px',
    lineHeight: '100%',
    padding: '10px 16px',
  },

  '@media (max-width: 599px)': {
    width: '280px',
  },
});

export const PointerLocationNameWrap = styled.div({
  display: 'grid',
  gridTemplateColumns: 'auto auto',
  gridGap: '5px',
  alignItems: 'center',
  zIndex: 9999,
  cursor: 'pointer',
});

export const PointerImg = styled.div({
  position: 'absolute',
  bottom: '-10px',
  left: '50%',
  transform: 'translate(-50%,0%)',
});
